import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { Card, CardContent, CardHeader } from '../../ui/card';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../../ui/collapsible';

type Props = {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
  contentClassName?: string;
};

export default function PersonCollapsibleSection({
  title,
  description,
  actions,
  defaultOpen = false,
  children,
  contentClassName,
}: Readonly<Props>) {
  return (
    <Collapsible defaultOpen={defaultOpen}>
      <Card>
        <CardHeader className="flex flex-row items-start justify-between gap-4 space-y-0">
          <CollapsibleTrigger
            className={cn(
              'group flex flex-1 items-start gap-2 rounded-md text-left outline-none',
              'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
            )}
          >
            <ChevronDown
              className="mt-1 h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200 group-data-[state=open]:rotate-180"
            />
            <div className="space-y-1.5">
              <div className="text-lg font-semibold leading-none tracking-tight">{title}</div>
              {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
            </div>
          </CollapsibleTrigger>
          {actions ? (
            <div className="flex shrink-0 items-center gap-2" onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
              {actions}
            </div>
          ) : null}
        </CardHeader>
        <CollapsibleContent>
          <CardContent className={contentClassName}>{children}</CardContent>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  );
}
